<div class="my-3 h-[3px] rounded-sm bg-divider drop-shadow-md
    soundShapes:border-none soundShapes:drop-shadow-none soundShapes:h-[2px]
    lighthouse:rounded-none lighthouse:drop-shadow-none lighthouse:h-[1px]"></div>
